//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import Deals from './Table.vue';

export default {
  components: {
    Deals,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadCurrencies(),
      this.loadPaymentMethods(),
      this.loadRequisites(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('tradersCurrencies', {
      loadCurrencies: 'loadData',
    }),
    ...mapActions('tradersPaymentMethods', {
      loadPaymentMethods: 'loadData',
    }),
    ...mapActions('tradersRequisites', {
      loadRequisites: 'loadData',
    }),
  },
};
